<template>
  <div class="aboutusm" >
    <van-sticky>
      <div class="nav">
        <div class="left"><img src="../assets/mobile/logo@2x.png" ></div>
        <div class="right" @click="overlayshow = true"><img src="../assets/mobile/menu@2x.png" ></div>
      </div>
      <van-overlay :show="overlayshow" @click="overlayshow = false">
        <div class="wrapper" >
          <div class="nav" v-bind:class="{ 'navActive2': overlayshow }">
            <div class="left"><img src="../assets/mobile/logo@2x.png" ></div>
            <div class="right" @click="overlayshow = true"><img src="../assets/mobile/menu@2x.png" ></div>
          </div>
          <div class="navselect" @click="goIndex">
            <van-icon name="arrow" />首页
          </div>
          <div class="navselect" @click="toBg3">
            <van-icon name="arrow" />业务介绍
          </div>
          <div class="navselect"  @click="toBg4">
            <van-icon name="arrow" />合作伙伴
          </div>
          <div class="navselect" @click="toBg5">
            <van-icon name="arrow" />软件著作权
          </div>
          <div class="navselect" @click="toBg6">
            <van-icon name="arrow" />联系我们
          </div>
          <div class="navselect" @click="toRecruitm">
            <van-icon name="arrow" />诚聘英才
          </div>
        </div>
      </van-overlay>
    
      
      
    </van-sticky>
    <div class="top"></div>
    <div class="con1">
        <div class="title1">清  裔  钲</div>
        <div class="title2">CHANGINGPAY</div>
        <div class="content">
            <div class="point"></div>
            上海清裔钲商务咨询有限公司位于上海市浦东新区，是一家面向金融行业提供技术服务的高科技企业，定位服务于中国银联、商业银行、支付机构及其它金融机构。 
        </div>
        <div class="content">
            <div class="point"></div>
凭借专业的行业经验，过硬的技术实力，诚信的服务理念，公司向金融行业从业机构提供专业化的产品、服务和行业解决方案，赢得了诸多合作机构的一致认可，并与这些合作机构建立了良好的合作关系。
        </div>
        <div class="content">
            <div class="point"></div>
企业的竞争力最终都要通过人来体现。上海清裔钲商务咨询有限公司有一整套包括研发、测试、产品、运营、市场在内的稳定的专业团队，各部门分工明确、目标一致，有能力高效地、负责任地处理从系统研发到系统运营中遇到的各类问题。
        </div>
        <div class="content">
            <div class="point"></div>
            公司现在职员工50人左右，100%具有国内重点大学本科或以上学历，团队成员拥有丰富的金融科技行业业务经验，大部分曾服务于中国银联，商业银行或第三方支付机构，均为业内相关领域资深专家。  
        </div>
    </div>
    <div class="con2">
      <div class="title"><img src="../assets/mobile/title_01@3x.png" ></div>
      <van-swipe :loop="false" :width="320">
          <van-swipe-item><div class="itemcon first">
            <img src="../assets/mobile/star@3x.png" alt="">
            <div class="contitle">高新技术企业认证</div>
            <div class="line"></div>
            <div class="contxt">「高新技术企业」是在国家重点支持的高新技术领域内，持续进行研究开发与技术成果转化，形成企业核心自主知识产权，并以此为基础开展生产经营活动，在中国境内（不包括港、澳、台地区）注册一年以上的居民企业。 高新技术企业的认定，将有效地提高企业的科技研发管理水平，重视科技研发，提高企业核心竞争力</div>
          </div></van-swipe-item>
          <van-swipe-item><div class="itemcon second">
            <img src="../assets/mobile/star@3x.png" alt="">
            <div class="contitle">双软认证</div>
            <div class="line"></div>
            <div class="contxt">「双软认证」是指软件产品评估和软件企业评估；企业申请双软认证除了获得软件企业和软件产品的认证资质，同时也是对企业知识产权的一种保护方式，更可以让企业享受国家提供给软件行业的税收优惠政策。 主要意义：作为税收减免的重要依据，作为法律重点保护的依据，作为技术出资入股，作为申请科技成果的依据。</div>
          </div></van-swipe-item>
          <van-swipe-item><div class="itemcon last">
            <img src="../assets/mobile/star@3x.png" alt="">
            <div class="contitle">软件著作权及专利</div>
            <div class="line"></div>
            <div class="contxt">「公司目前拥有软件著作权39项，实用新型专利7项，发明专利1项。总知识产权数52项。 主要系统如下： 对账系统、交易系统、清算系统、销账系统、支付管理系统、代付系统、代收系统、风控系统、交易计费系统、短信信息系统、交易流水系统、内容转接系统、数据服务系统、数据迁移系统、用户信息系统等。</div>
          </div></van-swipe-item>
        </van-swipe>
    </div>
    <div class="con3">
      <div class="title"><img src="../assets/mobile/title_02@3x.png" ></div>
      <div class="box"><img src="../assets/mobile/competitiveness_01@3x.png" ></div>
      <div class="box"><img src="../assets/mobile/competitiveness_02@3x.png" ></div>
      <div class="box"><img src="../assets/mobile/competitiveness_03@3x.png" ></div>
      <div class="box"><img src="../assets/mobile/competitiveness_04@3x.png" ></div>
    </div>
      <div class="footer">
        <img src="../assets/mobile/logo@2x.png" >
        <div class="name">上海清裔钲商务咨询有限公司 贵阳清钲金融科技有限公司(c)</div>
        <div class="copyright"  @click="gobeian">2016-{{ currentYear }} All Rights Reserved 黔ICP备17007172号-1</div>
      </div>
      <div style="height:200px"></div>
           
    </div>
</template>
<script>
import BScroll from '@better-scroll/core'
export default {
  name: 'product_m',
  data (){
    return{
      currentYear: new Date().getFullYear(),
     
      overlayshow:false,
      
    }
  },
  methods:{
   toRecruitm(){
        
        this.$router.push('/recruit_m')
        
      },
   gobeian(){
        window.location.href = 'https://beian.miit.gov.cn/';
      },
      goIndex(){
        sessionStorage.setItem('nav','index')
        this.$router.push('/')
      },
    toBg3(){
         sessionStorage.setItem('nav','Bg3')
         this.$router.push('/')
      },
      toBg4(){
        sessionStorage.setItem('nav','Bg4')
         this.$router.push('/')
      },
      toBg5(){
        sessionStorage.setItem('nav','Bg5')
         this.$router.push('/')
      },
      toBg6(){
        sessionStorage.setItem('nav','Bg6')
         this.$router.push('/')
      },  

  },
  mounted(){
    
  }
}


</script>
<style scoped>
.aboutusm {
  width: 100%;

}
.aboutusm .top{
    width: 100%;
  background-image: url("../assets/mobile/header@3x.png");
  background-size: 100%;
  background-repeat: no-repeat;
  padding-top: 64%;
  margin-top: -40px;
}
.aboutusm .nav{
  width: 100%;
  background: rgba(11,21,37,0.80);
  height: 40px;
}
.aboutusm .nav .left{
  position: absolute;
  left: 0;
}
.aboutusm .nav .left img{
  width: 100px;
  height: 30px;
  margin-left: 10px;
  margin-top: 5px;
}
.aboutusm .nav .right{
  float: right;
}
.aboutusm .nav .right img{
  width: 20px;
  height: 20px;
  margin-right: 10px;
  margin-top: 10px;
}
.aboutusm .navActive2{
  background-color: #0B1525 ;
}
.aboutusm .navselect{
  width: 100%;
  height: 60px;
  background: #0B1525;
  line-height: 60px;
  font-family: PingFangSC-Regular;
font-size: 14px;
color: #FFFFFF;
text-align: left;
}
.aboutusm .navselect .van-icon-arrow{
color: #DBBA66;
margin-left: 14px;
margin-right: 6px;
}
.aboutusm .con1{
    background: #FFFFFF;
box-shadow: 0 0 5px 0 rgba(0,0,0,0.10), 0 0 15px 0 rgba(0,0,0,0.10);
border-radius: 4px;
border-radius: 4px;
margin: 0 auto;
width: 280px;
height: 500px;
margin-top: -50px;
}
.aboutusm .con1 .title1{
    font-family: AlibabaPuHuiTiB;
font-size: 21px;
color: #333333;
letter-spacing: 0;
text-align: center;
padding-top: 20px;
font-weight: 600;
}
.aboutusm .con1 .title2{
    font-family: AlibabaPuHuiTiM;
font-size: 11px;
color: #E5C27E;
letter-spacing: 0.5px;
text-align: center;
margin-top: 1px;
margin-bottom: 18px;
}
.aboutusm .con1 .content{
    width: 210px;
    margin: 0 auto;
    font-family: PingFangSC-Regular;
font-size: 11px;
color: #151515;
text-align: justify;
line-height: 16px;
position: relative;
margin-bottom: 5px;
}
.aboutusm .con1 .content .point{
    width: 4px;
    height: 4px;
    background: #E5C27E;
    border-radius: 50%;
    position: absolute;
    left: -10px;
    top: 5px;
}
.aboutusm .con2 .title img{
  width: 300px;
  height: 45px;
  margin: 0 auto;
  margin-top: 30px;
}
.aboutusm .con2 .van-swipe-item{
background:transparent;
}
.aboutusm .con2 .itemcon{
box-shadow: 0 0 5px 0 rgba(0,0,0,0.10), 0 0 15px 0 rgba(0,0,0,0.10);
border-radius: 4px;
border-radius: 4px;
height: 240px;
width: 280px;
margin: 0 auto;
margin-top: 20px;
background-color: #fff;
position: relative;
}
.aboutusm .con2 .itemcon .itemhead{
  margin: 0 auto;
  margin-top: 30px;
  font-family: PingFangSC-Semibold;
font-size: 18px;
color: #333333;
text-align: center;
height: 60px;
}
.aboutusm .con2 .itemcon .itemhead img{
  width: 60px;
  height: 60px;
  display: block;
  position: absolute;
  top: 30px;
  left: 62px;
}
.aboutusm .con2 .itemcon img{
  width: 12px;
  height: 12px;
  position: absolute;
  left: 31px;
  top: 41px;
}
.aboutusm .con2 .itemcon .contitle{
  font-family: PingFangSC-Semibold;
font-size: 14px;
color: #333333;
position: absolute;
font-weight: 600;
  left:48px;
  top: 38px;

}
.aboutusm .con2 .itemcon .line{
 width: 220px;
 height: 1px;
 background: #EEEEEE;
 position: absolute;
 left: 30px;
 top: 69px;
}
.aboutusm .con2 .itemcon .contxt {
 width: 220px;
font-family: PingFangSC-Regular;
font-size: 11px;
color: #333333;
text-align: justify;
 position: absolute;
 left: 30px;
 top: 82px;
}
.aboutusm .con2 .first{
  margin-left: 40px;
}
.aboutusm .con2 .second{
  
}
.aboutusm .con2 .last{
  margin-right: 40px;
}
.aboutusm .con2 .second{
  width: 280px;
}
.aboutusm .con2 .van-swipe{
  height: 310px;
}
.aboutusm>>>.van-swipe__indicator{
width: 20px;
height: 5px;
border-radius: 0;
background: #e2e2e2;
}
.aboutusm>>>.van-swipe__indicator--active{
  background: #DBBA66;
}
.aboutusm .con3 .title img{
  width: 300px;
  height: 45px;
  margin: 0 auto;
  margin-top: 30px;
  margin-bottom: 20px;
}
.aboutusm .con3 .box img{
  width: 375px;
  height: 200px;
  margin: 0 auto;
  margin-bottom: 2px;
}


.aboutusm .footer{
     width: 100%;
  height: 130px;
  background-image: url("../assets/mobile/footer@2x.png");
  background-size: cover;
  background-repeat: no-repeat;
  position: fixed;
  bottom: 0;
}
.aboutusm .footer img{
width: 100px;
height: 30px;
margin:0 auto;
margin-top: 20px;
}
.aboutusm .footer .name{
  font-family: PingFangSC-Semibold;
  font-weight: 600;
font-size: 7px;
color: #FFFFFF;
text-align: center;
margin-top: 15px;
}
.aboutusm .footer .copyright{
  font-family: PingFangSC-Semibold;
font-size: 7px;
color: #848991;
text-align: center;
margin-top: 3px;
}



</style>